import type { StorageDriver } from '../types';
import { MemoryDriver } from './memory-driver';

const TEST_KEY = 'ElfsightLibraryStorageTest';

function getLocalStorage() {
  try {
    window.localStorage.setItem(TEST_KEY, 'true');
    window.localStorage.removeItem(TEST_KEY);
    return window.localStorage;
  } catch {
    return undefined;
  }
}

function getSessionStorage() {
  try {
    window.sessionStorage.setItem(TEST_KEY, 'true');
    window.sessionStorage.removeItem(TEST_KEY);
    return window.sessionStorage;
  } catch {
    return undefined;
  }
}

export function defineDriver(): StorageDriver | undefined {
  return getLocalStorage() || getSessionStorage() || new MemoryDriver();
}
